import { useNavigate } from 'react-router-dom';
import './create-instructor.css';
import CloseButton from '../../components/CloseButton';
import { useState } from 'react';
import Input from '../../components/Input';
import TextArea from '../../components/TextArea';
import { create, post } from '../../services/api';
import { useUI } from '../../UIContext';
import { handleErr } from '../../utils/functions';
import PhotoInput from '../../components/PhotoInput';

function CreateInstructor() {
    const navigate = useNavigate();

    const { setLoading, setMessage } = useUI();
    const [photo, setPhoto] = useState(undefined);
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [description, setDescription] = useState('');
    const [submitAttempt, setSubmitAttempt] = useState(false);
    const [hasSavedProcess, setHasSavedProcess] = useState(false);

    function isNameValid() {
        return !!name && name.length >= 2 && name.length <= 56;
    }

    function isLastNameValid() {
        return !!lastName && lastName.length >= 2 && lastName.length <= 200;
    }

    function isDescriptionValid() {
        return !description || description.length <= 400;
    }

    function clearScreen() {
        setSubmitAttempt(false);
        setPhoto(undefined);
        setName('');
        setLastName('');
        setDescription('');
    }

    async function onClickSave(e) {
        function isSaveValid() {
            setSubmitAttempt(true);

            return !!name && !!lastName;
        }

        function showSuccess() {
            setHasSavedProcess(true);
            setMessage({ type: 'success', text: 'O professor foi cadastrado.' });
        }

        e.preventDefault();

        if (!isSaveValid())
            return;

        setLoading(true);

        const data = {
            name,
            lastName,
            description: description || null
        };

        await create('instructor', data, true, setMessage,
            async (response) => {
                clearScreen();
                
                if (!photo) {
                    showSuccess();
                    return;
                }

                const formData = new FormData();
                formData.append('photo', photo);
                await post(`instructor/${response.data.id}/photo`, formData, true, setMessage,
                    () => {
                        showSuccess();
                    },
                    (err) => {
                        handleErr(setMessage, `Não foi possível salvar a foto do professor: ${err}`);
                    },
                    () => {
                        setLoading(false);
                    }
                )
            },
            (err) => {
                handleErr(setMessage, `Não foi possível cadastrar o professor: ${err}`);
            },
            () => {
                if (!photo)
                    setLoading(false);
            }
        );
    }

    return (
        <form className='default-form'>
            <header className='container-header'>
                <h1>Novo Professor</h1>

                <CloseButton
                    onClick={() => navigate('/instructors')}
                    shouldConfirm={!hasSavedProcess}
                />
            </header>

            <div className='instructor-photo-container'>
                <PhotoInput
                    photo={photo}
                    onChange={(file) => setPhoto(file)}
                    onRemove={() => setPhoto(undefined)}
                />
            </div>

            <Input
                className='commom-input glass-effect-15'
                type='text'
                value={name}
                onChange={(e) => setName(e.target.value)}
                onValidate={isNameValid}
                placeholder='Nome'
                shouldValidate={submitAttempt}
                maxLength={56}
                warningMsg='O nome deve conter ao menos 2 caracteres.'
            />

            <Input
                className='commom-input glass-effect-15'
                type='text'
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                onValidate={isLastNameValid}
                placeholder='Sobrenome'
                shouldValidate={submitAttempt}
                maxLength={200}
                warningMsg='O sobrenome deve conter ao menos 2 caracteres.'
            />

            <TextArea
                rows={5}
                className='commom-input glass-effect-15'
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                onValidate={isDescriptionValid}
                placeholder='Descrição (opcional)'
                shouldValidate={submitAttempt}
                maxLength={400}
                warningMsg='A descrição deve conter no máximo 400 caracteres.'
            />

            <div className='container-save-form'>
                <button
                    type='submit'
                    onClick={onClickSave}
                    className='blue-button zoom-effect'>
                    Salvar
                </button>
            </div>
        </form>
    );
}

export default CreateInstructor;